// extracted by mini-css-extract-plugin
export default {"amount":"style_amount__FmgqG","redColor":"style_redColor__T0HB8","greenColor":"style_greenColor__FfP5t","summaryCell":"style_summaryCell__zcLN4","content":"style_content__De7Q0"};